import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class StartEnablingAutomaticInvoicingError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('StartEnablingAutomaticInvoicingError', ...args);
    }
}
export default StartEnablingAutomaticInvoicingError;
